import useStaffAttendance from "./use-staff-attendance";
import useStaffCheckQr from "./use-staff-check-qr";
import useStaffWorkerSessions from "./use-staff-worker-sessions";
import useStaffWorkSessionsExportExcel from "./use-staff-work-sessions-export-excel";


const StaffManagementHooks = {
    useStaffAttendance,
    useStaffCheckQr,
    useStaffWorkerSessions,
    useStaffWorkSessionsExportExcel,
};

export default StaffManagementHooks;
